import { Component, Input, OnChanges, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { ImageChangedEvent } from '../../models/image.interface';
import { ImageService } from '../../services/image.service';
import { MatDialog } from '@angular/material/dialog';
import { ImageEditorModalComponent } from '../../modals/image-editor-modal/image-editor-modal.component';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'app-image-view',
  templateUrl: './image-view.component.html',
  styleUrls: ['./image-view.component.scss']
})
export class ImageViewComponent implements OnChanges {

  @Input()
  src: string;

  @Input()
  alt = '/assets/images/no-image-icon v2.png';

  @Input()
  nosrc: string;

  @Input()
  showVerifiedBadge = false;

  // data to get external reference to what object this image refers to.
  // no used in this component
  @Input()
  // tslint:disable-next-line: variable-name
  context_data: any;

  /**
   * User can edit (crop, resize) the image
   * not implemented yet
   */
  @Input()
  editable = false;

  /** User can change the image */
  @Input()
  changeable = false;

  @Input()
  maxHeight = '100vh';

  @Input()
  maxWidth = '100vw';




  @Input()
  radius = '0%';

  @Input()
  elevation = 0;

  @Input()
  imageSize: string;

  @Input()
  progress: 0;

  @Input()
  enableRotation = false;

  @Input()
  border: 'none';

  @Input()
  draggable = false;

  @Input()
  backgroundStyle = {}

  // tslint:disable-next-line: no-output-on-prefix
  @Output()
  onChange: EventEmitter<ImageChangedEvent> = new EventEmitter();


  @ViewChild('dom_image', { static: true })
  imageElement: ElementRef<HTMLImageElement>;

  _backgroundStyle = {};

  showBadge = false;

  fileSize: 48 | 64 | 128 | 256 | 512 | 'original' = 48;
  rotation = 0;
  imageSource: string | FileReader = 'assets/loaders/loader_ios.gif';
  noImage = 'assets/images/no-image-icon-small.png';
  imageChanged = false;
  editingImage;
  newImageInput: HTMLInputElement;
  modified = false;

  constructor(
    private service: ImageService,
    private dialog: MatDialog
  ) { }

  ngOnChanges() {

    this._backgroundStyle = {
        'border-radius': this.radius,
        backgroundColor: 'white'
       }

    if (this.backgroundStyle) {
      Object.assign(this._backgroundStyle, this.backgroundStyle);
    }

    // if was modified internally, does not update from src
    if (this.modified) {
      return;
    }

    if (!this.src && this.nosrc) {
      this.noImage = this.nosrc;
    }
    this.defineSize();
    this.setReceivedImage();

    if (this.showVerifiedBadge) {
      if (this.context_data) {
        if (this.context_data.verified) {
          this.showBadge = true;
        }
      } else {
        this.showBadge = true;
      }
    }

  }

  onFileChanged(event: Event) {
    const input = event.target as HTMLInputElement;

    const dialogRef = this.dialog.open(ImageEditorModalComponent, {
      width: '100%',
      height: '100%',
      maxWidth: '100%',
      maxHeight: '100%',
      backdropClass: 'dialog-backdrop',
      data: {
        image: input.files[0],
        options: {
          minCropWidth: 750, // Implemented in wrapper (not supported in cropper.js)
          minCropHeight: 750, // Implemented in wrapper (not supported in cropper.js)
          movable: true,
          scalable: true,
          zoomable: true,
          viewMode: 3,
          aspectRatio: 1,
        }
      }
    });

    dialogRef.afterClosed().subscribe();

    return;
  }

  changeImage() {
    const dialogRef = this.dialog.open(ImageEditorModalComponent, {
      width: '100%',
      height: '100%',
      maxWidth: '100%',
      maxHeight: '100%',
      backdropClass: 'dialog-backdrop',
      data: {
        image: null
      }
    });

    dialogRef.afterClosed().subscribe((result: string) => {
      if (result) {
        fetch(result)
          .then(res => res.blob())
          .then(blob => {
            const file = new File([blob], '', { type: 'image/png' });
            this.imageSource = result;
            this.onChange.emit({
              image: file
            });
            this.imageChanged = false;
            this.modified = true;
          });

      }

    });
  }

  defineSize() {

    if (this.imageSize === 'original') {
      this.fileSize = 'original';
      return;
    }
    const requested = +this.imageSize;

    if (requested <= 48) {
      this.fileSize = 48;
    } else if (requested <= 64) {
      this.fileSize = 64;
    } else if (requested <= 128) {
      this.fileSize = 128;
    } else if (requested <= 256) {
      this.fileSize = 256;
    } else {
      this.fileSize = 512;
    }

  }

  setReceivedImage() {
    if (!this.src) {
      this.imageSource = this.noImage;
      return;
    }
    if (!this.service) { return; }
    this.service.getUrl(this.src, this.fileSize.toString() as '48')
      .then(path => {
        if (!path) {
          this.imageSource = this.alt ?? this.noImage;
          return;
        }

        this.imageSource = path;
      })
      .catch(err => {
        this.imageSource = this.alt ?? this.noImage;
      });
  }

  getClasses() {
    let res = '';

    if (this.progress > 0) {
      res += ' hidden';
    }

    if (this.elevation > 0) {
      res += 'mat-elevation-z' + this.elevation;
    }

    if (this.rotation > 0) {
      res += ' rotate' + this.rotation;

    }
    return res;
  }

  cancelChange() {
    this.setReceivedImage();
    this.imageChanged = false;
    this.newImageInput = null;
  }

  isDraggable() {
    return this.draggable;
  }

  onImageClick() {
    if (this.changeable) {
      this.changeImage();
    }
  }

  getImageHeight() {
    return this.imageSize + 'px';
  }

  rotateRigth() {
    this.rotation += 90;
    if (this.rotation >= 360) {
      this.rotation = 0;
    }
    this.imageElement.nativeElement.style.transform = `rotate(${this.rotation}deg)`;
  }

  rotateLeft() {
    this.rotation -= 90;
    if (this.rotation <= -360) {
      this.rotation = 0;
    }
    this.imageElement.nativeElement.style.transform = `rotate(${this.rotation}deg)`;
  }

}
